export default __webpack_public_path__ + "static/Daria-de02a9f98ff61f37f21c753629c0559a.png";